import PropTypes from 'prop-types';
import {
    FJGenderSelector,
    FJProfessionSelector,
    FJHairPreferenceSelector,
    FJClothingPreferenceSelector,
    FJBackgroundPreferenceSelector,
    FJThemeSelector,
    FJRatioSelector,
    FJAgeSelector,
    FJGeneratingPlaceholder,
} from './steps';
import FJImageUploadValidatorContainer from '../container/FJImageUploadValidatorContainer';
import { DYNAMIC_STEPS_CONFIG } from '../../../../config/dataConfig/FJHeadshotGeneratorData';

const FJDynamicStepFormRenderer = ({
    currentStepIndex,
    selectedCategory,
    selectedCategoryKey,
    selectedGender,
    selectedProfession,
    selectedHairPreferences,
    selectedClothingPreference,
    selectedBackgroundPreference,
    selectedTheme,
    selectedRatio,
    selectedShot,
    onGenderChange,
    onProfessionChange,
    onHairPreferencesChange,
    onClothingPreferenceChange,
    onBackgroundPreferenceChange,
    onThemeChange,
    onRatioChange,
    onShotChange,
    onBack,
    hairColorNewOption,
    setHairColorNewOption,
    selectedAge,
    onAgeChange,
}) => {
    // 根据选择的分类动态获取步骤
    const getStepsByCategory = category => {
        return DYNAMIC_STEPS_CONFIG[category] || [];
    };

    const steps = getStepsByCategory(selectedCategory);
    const currentStep = steps[currentStepIndex];

    if (!currentStep) {
        return <div>步骤配置错误</div>;
    }

    // 根据当前步骤渲染对应的表单
    const renderStepForm = () => {
        switch (currentStep.key) {
            case 'gender':
                return (
                    <FJGenderSelector
                        selectedGender={selectedGender}
                        onGenderChange={onGenderChange}
                        selectedCategoryKey={selectedCategoryKey}
                        selectedCategory={selectedCategory}
                    />
                );
            case 'profession':
                return (
                    <FJProfessionSelector
                        selectedProfession={selectedProfession}
                        onProfessionChange={onProfessionChange}
                        gender={selectedGender}
                    />
                );
            case 'hair':
                return (
                    <FJHairPreferenceSelector
                        selectedHairPreferences={selectedHairPreferences}
                        onHairPreferencesChange={onHairPreferencesChange}
                        gender={selectedGender}
                        hairColorNewOption={hairColorNewOption}
                        setHairColorNewOption={setHairColorNewOption}
                    />
                );
            case 'clothing':
                return (
                    <FJClothingPreferenceSelector
                        selectedClothingPreference={selectedClothingPreference}
                        onClothingPreferenceChange={onClothingPreferenceChange}
                        gender={selectedGender}
                    />
                );
            case 'background':
                return (
                    <FJBackgroundPreferenceSelector
                        selectedBackgroundPreference={selectedBackgroundPreference}
                        onBackgroundPreferenceChange={onBackgroundPreferenceChange}
                        gender={selectedGender}
                    />
                );
            case 'ratio':
                return (
                    <FJRatioSelector
                        selectedRatio={selectedRatio}
                        onRatioChange={onRatioChange}
                        selectedShot={selectedShot}
                        onShotChange={onShotChange}
                        gender={selectedGender}
                    />
                );
            case 'age':
                return <FJAgeSelector selectedAge={selectedAge} onAgeChange={onAgeChange} />;
            case 'theme':
                return (
                    <FJThemeSelector
                        selectedProfession={selectedProfession}
                        selectedTheme={selectedTheme}
                        onThemeChange={onThemeChange}
                        selectedCategoryKey={selectedCategoryKey}
                        gender={selectedGender}
                    />
                );
            case 'upload':
                return <FJImageUploadValidatorContainer />;
            case 'generate':
                return <FJGeneratingPlaceholder onBack={onBack} />;
            default:
                return null;
        }
    };

    return <>{renderStepForm()}</>;
};

FJDynamicStepFormRenderer.propTypes = {
    currentStepIndex: PropTypes.number,
    selectedCategory: PropTypes.string,
    selectedCategoryKey: PropTypes.string,
    selectedGender: PropTypes.string,
    selectedProfession: PropTypes.object,
    selectedHairPreferences: PropTypes.object,
    selectedClothingPreference: PropTypes.object,
    selectedBackgroundPreference: PropTypes.array,
    selectedTheme: PropTypes.array,
    selectedRatio: PropTypes.object,
    selectedShot: PropTypes.object,
    onGenderChange: PropTypes.func,
    onProfessionChange: PropTypes.func,
    onHairPreferencesChange: PropTypes.func,
    onClothingPreferenceChange: PropTypes.func,
    onBackgroundPreferenceChange: PropTypes.func,
    onThemeChange: PropTypes.func,
    onRatioChange: PropTypes.func,
    onShotChange: PropTypes.func,
    onStartGeneration: PropTypes.func,
    onBack: PropTypes.func,
    hairColorNewOption: PropTypes.object,
    setHairColorNewOption: PropTypes.func,
    selectedAge: PropTypes.object,
    onAgeChange: PropTypes.func,
};

export default FJDynamicStepFormRenderer;
